import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import OrbitNavbar from '../../components/OrbitNavbar';
import OrbitReveal from './OrbitReveal';

/** Scroll to top on Orbit route changes (smooth when allowed). */
function OrbitScrollTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, left: 0, behavior: reduce ? 'auto' : 'smooth' });
  }, [pathname]);

  return null;
}

/** Shared chrome for all public Orbit pages */
const OrbitShell = ({ children }) => (
  <>
    <OrbitScrollTop />
    <OrbitReveal />
    <OrbitNavbar />
    {children}
  </>
);

export default OrbitShell;
